import { render, staticRenderFns } from "./TransferDetails.vue?vue&type=template&id=21eccaa6&"
import script from "./TransferDetails.vue?vue&type=script&lang=ts&"
export * from "./TransferDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports